import { render, staticRenderFns } from "./ImageTabs.vue?vue&type=template&id=acf2d226&scoped=true"
import script from "./ImageTabs.vue?vue&type=script&lang=js"
export * from "./ImageTabs.vue?vue&type=script&lang=js"
import style0 from "./ImageTabs.vue?vue&type=style&index=0&id=acf2d226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf2d226",
  null
  
)

export default component.exports